import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/execute-time.actions';
import { Col, Row, Form, Modal, Select, Input, Upload, Icon, DatePicker, TimePicker } from 'antd';
import { dspxGetChildrens, dspxGetWorkerChildrens } from '../helpers/dspx-utils'
import { ReactComponent as SetMasterIcon } from '../resource/forms/Builder.svg';
import { MODAL_UNSAVED_DATA_WARNING_TITLE, UNSAVED_DATA_WARNING_TEXT } from '../constants/text.constants';

const MasterForm = Form.create()(
	class extends React.Component {

		render() {
			const { visible, onCancel, onCreate, form, fprops, confirmLoading } = this.props;
			const { getFieldDecorator } = form;

			return (
				<Modal className='dspx-icon-header'
					width={400}
					visible={visible}
					title={<span><SetMasterIcon style={{ height: 50, verticalAlign:'middle', marginRight: 10 }}/> Назначить мастера</span>}
					confirmLoading={confirmLoading}
					onCancel={onCancel}
					onOk={onCreate} >
					<Form layout="vertical">
					{getFieldDecorator('request', { initialValue: fprops.request })(
							<Input type='hidden' />)}

						<Row gutter={16}>
							<Col span={24}>
								<Form.Item label="Мастер" >
									{getFieldDecorator('masterId', 
											{ initialValue: (fprops.master && fprops.listWorker.some(e => e.id == fprops.master)) ? fprops.master : undefined,
												rules: [{ required: true, message: 'Пожалуйста, выберите мастера' }]
											})(
										<Select
											showSearch
											placeholder="мастер"
											notFoundContent='нет данных'
											optionLabelProp="label"
											optionFilterProp="searchtext" >
											{dspxGetWorkerChildrens(fprops.listWorker)}
										</Select>)}
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
			);
		}
	});

class MasterContainer extends Component {
	state = {
		confirmLoading: false,
	};
	
	handleCancel = () => {
		return new Promise((resolve) => {
			const form = this.formRef && this.formRef.props && this.formRef.props.form;
			const hasTouchedFields = form && typeof form.isFieldsTouched === 'function' ? form.isFieldsTouched() : false;

			if (hasTouchedFields) {
				Modal.confirm({
					title: MODAL_UNSAVED_DATA_WARNING_TITLE,
					content: UNSAVED_DATA_WARNING_TEXT,
					okType: 'danger',
					okText: 'Да',
					cancelText: 'Отмена',
					onOk: () => {
						this.resetAndClose();
						resolve(true);
					},
					onCancel: () => resolve(false),
				});
				return;
			}

			this.resetAndClose();
			resolve(true);
		});
	}

	resetAndClose = () => {
		const form = this.formRef && this.formRef.props && this.formRef.props.form;
		if (form) form.resetFields();
		this.props.dispatch(actions.closeMasterModal());
	}

	handleCreate = () => {
		const form = this.formRef.props.form;		

		form.validateFields(async (err, values) => {
			if (err) return;
			if (typeof this.props.updateMaster === 'function') {
				this.setState({
					confirmLoading: true,
				});

				await this.props.updateMaster(values);

				this.setState({
					confirmLoading: false,
				});
			} else {
				this.props.dispatch(actions.postMaster(values));
			}

			form.resetFields();
			this.props.dispatch(actions.closeMasterModal());
		});
	}

	saveFormRef = (formRef) => {
		this.formRef = formRef;
	}

	render() {

		return (
			<MasterForm
				wrappedComponentRef={this.saveFormRef}
				visible={this.props.masterModalVisible}
				dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
				fprops={this.props}
				confirmLoading={this.state.confirmLoading}
			/>
		)
	}
}

function mapStateToProps(state) {
	const { executeTimeStore } = state;
	const { listWorker } = state.newRequestStore;

	return { ...executeTimeStore, listWorker };
}

export default connect(mapStateToProps)(MasterContainer);
